var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", {
    staticClass: "member-child-selector__child-list-item",
    domProps: { innerHTML: _vm._s(_vm.decode(_vm.member.name)) },
    on: {
      click: function($event) {
        $event.preventDefault()
        return _vm.changeMemberBeingViewed($event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }